import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=0173b0cf&scoped=true"
import script from "./RightMenu.vue?vue&type=script&lang=js"
export * from "./RightMenu.vue?vue&type=script&lang=js"
import style0 from "./RightMenu.vue?vue&type=style&index=0&id=0173b0cf&lang=scss"
import style1 from "./RightMenu.vue?vue&type=style&index=1&id=0173b0cf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0173b0cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0173b0cf')) {
      api.createRecord('0173b0cf', component.options)
    } else {
      api.reload('0173b0cf', component.options)
    }
    module.hot.accept("./RightMenu.vue?vue&type=template&id=0173b0cf&scoped=true", function () {
      api.rerender('0173b0cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Meet/RightMenu/RightMenu.vue"
export default component.exports